import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useInvalidateIntegrationByAccountId } from '@/entities/integrations';
import { ApiError } from '@/shared/api/ApiError';

import {
  openAmoCrmOAuthPopup,
  runAmoCrmOAuth,
} from './amocrmOAuth';

export function useConnectAmoCrmIntegration() {
  const { t } = useTranslation();
  const invalidateIntegrations = useInvalidateIntegrationByAccountId();

  return useMutation({
    mutationFn: async () => {
      const popup = openAmoCrmOAuthPopup();
      if (!popup) {
        throw new Error(t('integrations:oauth.errors.popupBlocked'));
      }

      try {
        return await runAmoCrmOAuth(popup, {
          popupClosed: t('integrations:oauth.errors.popupClosed'),
          popupTimeout: t('integrations:oauth.errors.popupTimeout'),
          invalidStartResponse: t('integrations:oauth.errors.startFailed'),
          missingReferer: t('integrations:oauth.errors.missingReferer'),
          exchangeFailed: t('integrations:oauth.errors.exchangeFailed'),
          oauthFailed: t('integrations:oauth.errors.failed'),
        });
      } catch (error) {
        throw ApiError.fromError(error);
      }
    },
    onSuccess: () => {
      invalidateIntegrations();
    },
  });
}
